import { ApiFunc, getInstance } from '@helpers/httpClient'
import { dissoc, prop } from 'ramda'

import * as API from '../constants/api'

const instance = getInstance()

export const academicYear: ApiFunc<`/${typeof API.ACADEMIC_YEAR}`, 'get'> = data =>
  instance.get(`${API.ACADEMIC_YEAR}${'id' in data ? prop('id', data) : data?.name}`, {
    params: 'id' in data ? dissoc('id', data) : dissoc('name', data),
  })

export const academicYearCreate: ApiFunc<`/${typeof API.ACADEMIC_YEAR}`, 'post'> = data =>
  instance.post(API.ACADEMIC_YEAR, data)

export const academicYearDelete: ApiFunc<`/${typeof API.ACADEMIC_YEAR}{id}`, 'delete'> = data =>
  instance.delete(`${API.ACADEMIC_YEAR}${'id' in data ? prop('id', data) : prop('name', data)}`)

export const academicYearList: ApiFunc<`/${typeof API.ACADEMIC_YEAR}`, 'get'> = data =>
  instance.get(API.ACADEMIC_YEAR, {
    params: data,
  })

export const academicYearAll: ApiFunc<`/${typeof API.ACADEMIC_YEAR_ALL}`, 'get'> = data =>
  instance.get(API.ACADEMIC_YEAR_ALL, {
    params: data,
  })
